import { render } from "./PendingContractsIndex.vue?vue&type=template&id=f1cfc564"
import script from "./PendingContractsIndex.vue?vue&type=script&lang=js"
export * from "./PendingContractsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__